<template>
  <el-dialog :title="form.mrpRunId ? '修改MRP批次' : '新增MRP批次'" :visible.sync="visible" width="720px" append-to-body :close-on-click-modal="false" @closed="onClosed">
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="批次号" prop="mrpRunCode">
        <el-input v-model="form.mrpRunCode" :disabled="codeReadonly" placeholder="留空自动编号" />
      </el-form-item>
      <el-form-item label="运算日期" prop="runDate">
        <el-date-picker v-model="form.runDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
      <el-form-item label="计划起">
        <el-date-picker v-model="form.planStartDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
      <el-form-item label="计划止">
        <el-date-picker v-model="form.planEndDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'
}

export default {
  name: 'MrpRunAddOrUpdate',
  data() {
    return {
      visible: false,
      saving: false,
      codeReadonly: false,
      form: { mrpRunId: '', mrpRunCode: '', runDate: '', planStartDate: '', planEndDate: '', remark: '' },
      rules: {
        runDate: [{ required: true, message: '运算日期不能为空', trigger: 'change' }]
      }
    }
  },
  methods: {
    onClosed() {
      this.form = { mrpRunId: '', mrpRunCode: '', runDate: '', planStartDate: '', planEndDate: '', remark: '' }
      this.codeReadonly = false
      this.saving = false
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'mrpRun' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.form.mrpRunCode = data.previewCode
      }).catch(() => {})
    },
    init(id) {
      this.visible = true
      if (id) {
        request.get('/plan/mrp/info', { params: { id } }).then(res => {
          const row = res.data || {}
          this.form = {
            mrpRunId: row.mrpRunId || id,
            mrpRunCode: row.mrpRunCode || '',
            runDate: row.runDate || '',
            planStartDate: row.planStartDate || '',
            planEndDate: row.planEndDate || '',
            remark: row.remark || ''
          }
          this.codeReadonly = !!this.form.mrpRunCode
        }).catch(() => {})
        return
      }
      this.form = { mrpRunId: '', mrpRunCode: '', runDate: today(), planStartDate: '', planEndDate: '', remark: '' }
      this.resolveCode()
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    submit() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.saving = true
        request.post('/plan/mrp/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.saving = false })
      })
    }
  }
}
</script>
